import { Component, OnInit } from '@angular/core';
import {SkillsComponent} from "../homepage/skills.component";
import { GlobalServiceService } from '../global-service.service';

@Component({
  selector: 'app-statistics',
  templateUrl: './statistics.component.html',
  styleUrls: ['./statistics.component.css']
})
export class StatisticsComponent implements OnInit {
  height: number;
  width: number;
  proportion: number = 0.283;
  isFired: boolean = false;

  constructor(private service: GlobalServiceService) { }

  ngOnInit(){
    this.onResize();
  }

  onResize(){
    this.height = this.service.getHeight(this.proportion);
  }

  onScroll(){
    let desiredTime = 6000;
    let inScroll = SkillsComponent.isElementInViewport($('.container-statistics'));
    if (inScroll == true){
      if (!this.isFired){
       this.numberAnimation($('.statistics:nth-child(1) h3'), 1245, StatisticsComponent.getBreakLength(1245, desiredTime));
        this.numberAnimation($('.statistics:nth-child(2) h3'), 113, StatisticsComponent.getBreakLength(113, desiredTime));
        this.numberAnimation($('.statistics:nth-child(3) h3'), 134, StatisticsComponent.getBreakLength(134, desiredTime));
        this.numberAnimation($('.statistics:nth-child(4) h3'), 123, StatisticsComponent.getBreakLength(123, desiredTime));
      }
      this.isFired = true;
    }
  }


  numberAnimation(el: any, percent : number, time: number) {
    let i = 0;
    setInterval(function() {
      i = i+7;
      if (i < percent) {
        el.text(i);
      }
    }, time);
  }

  static getBreakLength (finalNumber: number, desiredTime: number) {
    return desiredTime / finalNumber;
  }

}



// WEBPACK FOOTER //
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/app/about us/statistics.component.ts